import React from 'react';

export const acceptanceCashMovementConfig = [
  {
    path: '/service-cash-movement-acceptance',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/service-cash-movement-acceptance/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/service-cash-movement-acceptance/view',
    component: React.lazy(() => import('./view/view')),
  },
  {
    path: '/service-cash-movement-acceptance/check-in',
    component: React.lazy(() =>
      import('./checkInCashMovement/checkInCashMovement'),
    ),
  },
  {
    path: '/service-cash-movement-acceptance/complete-order',
    component: React.lazy(() => import('./completeOrder/completeOrder')),
  },
];
